// extracted by mini-css-extract-plugin
module.exports = {"container":"slider_container__2k6ki","horizontalSlider":"slider_horizontalSlider__Bjnvp","track":"slider_track__oOKnj","thumb":"slider_thumb__rxMYO"};